module.exports = __webpack_public_path__ + "files/477511281c489eb91eec3b5aaf239e73.png";